import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Calendar, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Footer } from "../components/Footer";
import { CompactHeader } from "../components/CompactHeader";
import * as Constants from "../../constants";
import BackLoader from "../../components/backloader";
export default function NewsLanding() {
  const navigate = useNavigate();
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(false);

  const allNews = [
    {
      id: 1,
      title:
        "Lagos Chief Judge Inaugurates Local Government Election Petition Appeals Tribunal.",
      date: "2025-10-25",
      year: "2025",
      category: "Events",
      thumbnail: `${Constants.baseurl}/assets/landing_images/JIS-Gallery/Magistrates-Registrars-and-Sheriffs-Training-on-Small-Claims-Court/MRSTSCC-1.jpg`,
      excerpt:
        "The Chief Judge of Lagos State, Hon. Justice Kazeem Olanrewaju Alogba officially inaugurated the 2025",
    },
    {
      id: 2,
      title:
        "Lagos Judiciary Summit focuses on Artificial Intelligence for Justice Sector",
      date: "24-09-2025",
      year: "2025",
      category: "Events",
      thumbnail: `${Constants.baseurl}/assets/landing_images/JIS-Gallery/Magistrates-Registrars-and-Sheriffs-Training-on-Small-Claims-Court/MRSTSCC-2.jpg`,
      excerpt:
        "The Lagos State Chief Judge, Hon Justice Kazeem Alogba, has disclosed that the",
    },
    {
      id: 3,
      title:
        "Lagos Chief Judge Reaffirms Judiciary’s Commitment to Impartial Justice",
      date: "23-09-2025",
      year: "2025",
      category: "Innovation",
      thumbnail: `${Constants.baseurl}/assets/landing_images/JIS-Gallery/Magistrates-Registrars-and-Sheriffs-Training-on-Small-Claims-Court/MRSTSCC-3.jpg`,
      excerpt:
        "The Chief Judge of Lagos State, Justice Kazeem Alogba, has reaffirmed the judiciary’s",
    },
    {
      id: 4,
      title:
        "Lagos Judiciary Launches Non-Custodial Sentencing Practice Directiion.",
      date: "02-09-2025",
      year: "2025",
      category: "Events",
      thumbnail: `${Constants.baseurl}/assets/landing_images/JIS-Gallery/SpecialCourtSessioninHonourofLate-Mr-Adesina-Ogunlana-and-Late-Olabisi Adegunle/SCSHLAOLOA-1.jpg`,
      excerpt:
        "The Lagos State Judiciary has launched a new Practice Direction on Non-Custodial Sentencing.",
    },
    {
      id: 5,
      title: "LAGOS CJ INAUGURATES LOCAL GOVERNMENT ELECTION TRIBUNAL PANELS",
      date: "11-07-2025",
      year: "2025",
      category: "Innovation",
      thumbnail: `${Constants.baseurl}/assets/landing_images/JIS-Gallery/SpecialCourtSessioninHonourofLate-Mr-Adesina-Ogunlana-and-Late-Olabisi Adegunle/SCSHLAOLOA-2.jpg`,
      excerpt:
        "The Chief Judge of Lagos State, Hon. Justice Kazeem Olanrewaju Alogba, on Friday,",
    },
  ];

  const sortedNews = [...allNews].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  const [selectedCategory, setSelectedCategory] = useState("All");
  const [selectedYear, setSelectedYear] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleCount, setVisibleCount] = useState(6);

  useEffect(() => {
    onLoadNews();
  }, [selectedYear, selectedCategory]);
  const years = ["All", ...Array.from(new Set(allNews.map((n) => n.year)))];

  const recentNews = sortedNews.slice(0, 3);

  const filteredNews = sortedNews
    .filter(
      (n) =>
        (selectedCategory === "All" || n.category === selectedCategory) &&
        (selectedYear === "All" || n.year === selectedYear) &&
        n.title.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .slice(0, visibleCount);

  const onLoadNews = async () => {
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/cms/news/${
          selectedYear == "All" ? 0 : selectedYear
        }/${selectedCategory == "All" ? "all" : selectedCategory}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setNewsList(data.items);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
      <CompactHeader />
      {/* HERO SECTION */}
      <section className="relative py-12 bg-hero-light-image dark:bg-hero-dark">
        <div className="absolute inset-0 bg-black/10 dark:bg-black/30"></div>
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-4xl md:text-5xl font-bold mb-3 text-gray-900 dark:text-white">
            Latest News & Updates
          </h1>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto">
            Stay informed about the latest developments, initiatives, and
            announcements from the judiciary.
          </p>
        </div>
      </section>

      {/* MAIN CONTAINER */}
      <div className="container mx-auto max-w-6xl px-4 py-12">
        {/* FILTERS */}
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <div className="flex flex-wrap gap-3 items-center">
            {["All", "Innovation", "Events"].map((cat) => (
              <button
                key={cat}
                onClick={() => setSelectedCategory(cat)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition ${
                  selectedCategory === cat
                    ? "bg-blue-600 text-white"
                    : "bg-gray-200 dark:bg-gray-800 hover:bg-gray-300 dark:hover:bg-gray-700"
                }`}
              >
                {cat}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-3">
            {/* YEAR SELECT */}
            <select
              value={selectedYear}
              onChange={(e) => setSelectedYear(e.target.value)}
              className="px-3 py-2 rounded-lg bg-gray-200 dark:bg-gray-800 text-sm font-medium outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Filter by year"
            >
              {years.map((y) => (
                <option key={y} value={y}>
                  {y === "All" ? "All Years" : y}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* RECENT NEWS SECTION */}
        <section className="mb-12 bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-6">
          <h2 className="text-2xl font-semibold mb-6">Recent Highlights</h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {newsList
              ?.filter((d) => d.isHighlight)
              .map((news, idx) => (
                <motion.article
                  key={news.id}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: idx * 0.08 }}
                  className="rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700 hover:shadow-lg bg-gray-50 dark:bg-gray-900 flex flex-col"
                >
                  <img
                    src={`${Constants.docUrl}/cms/news/${news.coverImage}`}
                    alt={news.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-5 flex-1 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center text-sm text-gray-500 dark:text-gray-400 mb-2">
                        <Calendar className="w-4 h-4 mr-1" />
                        {new Date(news.newsOn).toLocaleDateString()}
                      </div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        {news.title}
                      </h3>
                      <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
                        {news.subTitle}
                      </p>
                    </div>
                    <button
                      onClick={() => navigate(`/news/${news.id}`)}
                      className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-full text-sm hover:bg-blue-700 transition"
                      aria-label={`Read more about ${news.title}`}
                    >
                      Read More →
                    </button>
                  </div>
                </motion.article>
              ))}
          </div>
        </section>

        {/* ALL NEWS SECTION */}
        <section className="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-6">
          <h2 className="text-2xl font-semibold mb-6">All News</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {newsList
              ?.filter((d) => !d.isHighlight)
              .map((news) => (
                <motion.article
                  key={news.id}
                  initial={{ opacity: 0, y: 12 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="rounded-2xl overflow-hidden border border-gray-200 dark:border-gray-700 hover:shadow-lg bg-gray-50 dark:bg-gray-900 flex flex-col"
                >
                  <img
                    src={news.thumbnail}
                    alt={news.title}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-5 flex-1 flex flex-col justify-between">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                        {news.title}
                      </h3>
                      <div className="text-sm text-gray-500 dark:text-gray-400 mb-2 flex items-center">
                        <Calendar className="w-4 h-4 mr-1" />
                        {new Date(news.date).toLocaleDateString()}
                      </div>
                      <p className="text-sm text-gray-700 dark:text-gray-300 mb-4">
                        {news.excerpt}
                      </p>
                    </div>
                    <button
                      onClick={() => navigate(`/news/${news.id}`)}
                      className="inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-white rounded-full text-sm hover:bg-blue-700 transition"
                      aria-label={`Read more about ${news.title}`}
                    >
                      Read More →
                    </button>
                  </div>
                </motion.article>
              ))}
          </div>

          {visibleCount < sortedNews.length && (
            <div className="text-center mt-10">
              <button
                onClick={() => setVisibleCount((v) => v + 6)}
                className="px-6 py-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition"
                aria-label="Load more news"
              >
                Load More
              </button>
            </div>
          )}
        </section>
      </div>
      <Footer />
      <BackLoader open={loading} />
    </div>
  );
}
